import { render, staticRenderFns } from "./dialog-tax-invoice.vue?vue&type=template&id=02256dd2&"
import script from "./dialog-tax-invoice.vue?vue&type=script&lang=js&"
export * from "./dialog-tax-invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports